import { bookService, projectService, attachmentService } from '@/services'
import { first, second, third, fourth, fifth, sixth } from './defaultPersonalProjects'
import { generateHTML } from '@/core/helper-functions'
import createTemplate from './createTemplate'
import createDefaultTask from './createDefaultTask'
import createDefaultEvent from './createDefaultEvent'

const images = [
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/190245/8289/1612030239102_3987361905400707.jpg',
    name: 'first.jpg',
    type: 'image/jpeg'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/199230/51148/1634487512785_2173879183459771.png',
    name: 'second.png',
    type: 'image/png'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/205485/103388/1647265982303_2261615984653268.png',
    name: 'third.png',
    type: 'image/png'
  }
]

export default async (commit, settings) => {
  // create first book
  const book = await bookService.create({
    title: 'My first space',
    subTitle: 'This is a space. Open it and start exploring'
  })

  await createDefaultTask(book.data.dataValues.id)
  await createDefaultEvent(book.data.dataValues.id)

  commit('loading', true)

  const firstProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Getting started',
    icon: 'partying-face',
    parentId: null,
    body: first(),
    html: generateHTML(first(), settings, 'Getting started')
  })

  const uploadedImages = {}

  for (const image of images) {
    commit('loading', true)

    const { data } = await attachmentService.proxy(image.url)

    const file = new File([data], image.name, { type: image.type })

    const formData = new FormData()
    formData.append('data', file, image.name)

    commit('loading', true)

    const response = await attachmentService.upload({
      projectId: firstProject.data.dataValues.id,
      data: formData
    })

    uploadedImages[image.name] = {
      id: response.data.id,
      url: response.data.url
    }
  }

  commit('loading', true)

  const secondProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'To-do',
    icon: 'check-mark',
    parentId: null,
    body: second(),
    html: generateHTML(second(), settings, 'To-do')
  })

  commit('loading', true)

  const thirdProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Grocery list',
    icon: 'shopping-cart',
    parentId: null,
    body: third(),
    html: generateHTML(third(), settings, 'Grocery list')
  })

  await projectService.edit(
    firstProject.data.dataValues.id,
    {
      title: 'Getting started',
      body: first(book.data.dataValues.id, thirdProject.data.dataValues.id, uploadedImages),
      html: generateHTML(first(book.data.dataValues.id, thirdProject.data.dataValues.id, uploadedImages), settings, 'Getting started')
    }
  )

  await projectService.edit(
    secondProject.data.dataValues.id,
    {
      title: 'To-do',
      body: second(book.data.dataValues.id, thirdProject.data.dataValues.id),
      html: generateHTML(second(book.data.dataValues.id, thirdProject.data.dataValues.id), settings, 'To-do')
    }
  )

  commit('loading', true)

  // add fourth project
  const fourthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'My favorites',
    icon: 'file-folder',
    parentId: null,
    body: fourth(),
    html: generateHTML(fourth(), settings, 'My favorites')
  })

  commit('loading', true)

  // add fifth project
  const fifthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Movies',
    icon: 'film-frames',
    parentId: fourthProject.data.dataValues.id,
    body: fifth(),
    html: generateHTML(fifth(), settings, 'Movies')
  })

  await projectService.edit(
    fourthProject.data.dataValues.id,
    {
      title: 'My favorites',
      body: fourth(book.data.dataValues.id, fifthProject.data.dataValues.id),
      html: generateHTML(fourth(book.data.dataValues.id, fifthProject.data.dataValues.id), settings, 'My favorites')
    }
  )

  commit('loading', true)

  // add sixth project
  const sixthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Meeting notes',
    icon: 'orange-book',
    parentId: null,
    body: sixth(),
    html: generateHTML(sixth(), settings, 'Meeting notes')
  })

  // create templates
  commit('loading', true)
  await createTemplate(settings, sixthProject.data.dataValues)
}
